<template>
  <transition name="fade">
    <div class="userModal" v-if="show">
      <div class="overlay" v-on:click="close(false)"></div>
      <div :class="{modalContent: true, modalBig: true}">
        <div class="close" v-on:click="close(false)"></div>
          <iframe src="https://audience.ahaslides.com/kxcfbttbns"
            style="width: 100%; height:560px">
            <p>Your browser does not support iframes.</p>
          </iframe>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      show: false,
    };
  },
  computed: {
  },
  methods: {
    open(d, n) {
      this.show = true;
    },
    close(b, d) {
      this.show = false;
    },
  },
};
</script>

<style scoped lang="scss">
  .userModal{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 991;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: auto;
    padding: 40px 0;
    @media (max-width: 680px) {
      padding: 20px 10px;
    }
    .overlay{
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
    }
    .modalContent{
      position: relative;
      z-index: 2;
      background: #ffe7ea;
      width: 860px;
      height: 480px;
      margin: auto;
      border-radius: 5px;
      transition: all .3s ease;
      iframe{
        border: none;
      }
      .close{
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-image: url(../assets/close.png);
        background-size: 14px auto;
        background-position: center;
        background-repeat: no-repeat;
        position: absolute;
        right: -10px;
        top: -10px;
        background-color: #fcdf51;
        cursor: pointer;
        transition: all .2s linear;
      }
      .close:hover{
        background-color: #fcdf51;
      }
    }
  }
</style>
